export default {"src":"/_next/static/media/Company_thumbnail.50a0afe2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};